module.exports = __webpack_public_path__ + "img/laminate_six.17c6a51f.png";